import { REPOSITORY } from '../../api/repository/Repository'
import { useEffect } from 'react'
const compareActivity = () => {
  const actualTime = localStorage.getItem('activity')
  if (!actualTime) {
    REPOSITORY.local.activity.saveActivity(Date.now())
  } else {
    REPOSITORY.local.activity.compareTimestamp()
  }
}
export default function useActivity() {
  useEffect(() => {
    document.addEventListener('click', () => {
      compareActivity()
    })
    compareActivity()
  }, [])
}
